import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Navbar, Nav, Accordion, Container, Offcanvas } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { HiMenu } from 'react-icons/hi';

import logoAr from 'src/assets/images/navbar/logo_ar.svg';
import logoEn from 'src/assets/images/navbar/logo_en.svg';
import logoIt from 'src/assets/images/navbar/logo_it.svg';

import { isRTL } from 'src/utils/global';
import styles from './styles.module.css';

const ICON_SIZE = 22;

const NavSmall = () => {
    const { t, i18n } = useTranslation("common");
    const [show, setShow] = useState<boolean>(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const getLinkClassName = ({ isActive }: { isActive: boolean }) =>
        `${styles.item__link} nav-link ${isActive ? styles.active : ''}`;

    const getSubLinkClassName = ({ isActive }: { isActive: boolean }) =>
        `${styles.accordion__link} nav-link ${isActive ? styles.active : ''}`;

    // ✅ Dynamically select logo based on language
    const currentLang = i18n.language;
    const logo =
        currentLang === 'ar'
            ? logoAr
            : currentLang === 'it'
                ? logoIt
                : logoEn;

    return (
        <header>
            <Navbar expand={false} className={`${styles.nav} ${styles.nav__sm} ${isRTL() && styles.rtl}`}>
                <Container>
                    {/* Logo */}
                    <Navbar.Brand className={styles.nav_brand} href="/">
                        <img src={logo} alt={t("nav.title")} className={styles.logo_img} />
                    </Navbar.Brand>

                    {/* Hamburger Toggle */}
                    <Navbar.Toggle
                        className={styles.toggle}
                        aria-controls="offcanvasNavbar-expand-xl"
                        onClick={handleShow}
                    >
                        <HiMenu size={ICON_SIZE + 4} />
                    </Navbar.Toggle>

                    <Navbar.Offcanvas
                        id="offcanvasNavbar-expand-xl"
                        aria-labelledby="offcanvasNavbarLabel-expand-xl"
                        placement={isRTL() ? "start" : "end"}
                        show={show}
                        onHide={handleClose}
                        className={`${styles.sm__offcanvas} ${isRTL() && styles.rtl__offcanvas}`}
                    >
                        <Offcanvas.Header closeButton className={styles.offcanvas__header}>
                            <Offcanvas.Title id="offcanvasNavbarLabel-expand-xl">
                                <img src={logo} alt={t("store_name")} height={50} width={123} />
                            </Offcanvas.Title>
                        </Offcanvas.Header>

                        <Offcanvas.Body className={styles.offcanvas__body}>
                            <Nav className="justify-content-end flex-grow-1">
                                <NavLink
                                    to="/"
                                    onClick={handleClose}
                                    className={getLinkClassName}
                                >
                                    {t("nav.home")}
                                </NavLink>

                                <Accordion className={styles.accordion}>
                                    <Accordion.Item eventKey="0" className={styles.accordion__item}>
                                        <Accordion.Header className={styles.accordion__header}>
                                            {t("nav.products")}
                                        </Accordion.Header>
                                        <Accordion.Body className={styles.accordion__body}>
                                            <NavLink className={getSubLinkClassName} to="/supplements">
                                                {t('nav.supplements')}
                                            </NavLink>
                                            <a className={`${styles.accordion__link} nav-link`}>
                                                {t('nav.medicines')}
                                            </a>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>

                                <NavLink
                                    to="/about"
                                    onClick={handleClose}
                                    className={getLinkClassName}
                                >
                                    {t("nav.about")}
                                </NavLink>

                                <NavLink
                                    to="/contact"
                                    onClick={handleClose}
                                    className={getLinkClassName}
                                >
                                    {t("nav.contact")}
                                </NavLink>
                            </Nav>
                        </Offcanvas.Body>
                    </Navbar.Offcanvas>
                </Container>
            </Navbar>
            <div className={styles.prop}></div>
        </header>
    );
}

export default NavSmall;
